import React, { useState, useEffect, useRef, useContext } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { Form, Button, Alert } from 'react-bootstrap'
import { useDispatch, useSelector } from 'react-redux'
import Message from '../components/Message.js'
import Loader from '../components/Loader.js'
import { loginOwner } from '../actions/ownerActions.js'
import FormContainer from '../components/FormContainer.js'
import { OWNER_LOGIN_RESET } from '../constants/ownerConstants.js'
import { ThemeContext } from '../components/ThemeContext.js'

const OwnerLoginScreen = () => {
  const { theme } = useContext(ThemeContext)
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [message, setMessage] = useState(null)

  const dispatch = useDispatch()
  const navigate = useNavigate()

  const inputRef = useRef()

  const ownerLogin = useSelector((state) => state.ownerLogin)
  const { loading, error, ownerInfo } = ownerLogin

  useEffect(() => {
    if (ownerInfo) {
      navigate('/ownerdashboard')
    } else {
      dispatch({ type: OWNER_LOGIN_RESET })
      if (inputRef.current) {
        inputRef.current.focus()
      }
    }
  }, [navigate, ownerInfo, dispatch])

  const submitHandler = (e) => {
    e.preventDefault()
    if (!email || !password) {
      setMessage('Please enter your email and password.')
      return
    }
    dispatch(loginOwner(email, password))
  }

  return (
    <FormContainer>
      <h3 style={{ color: theme.text }}>Business Login</h3>
      {message && (
        <Alert dismissible variant='warning' onClose={() => setMessage(null)}>
          {message}
        </Alert>
      )}
      {error && <Message variant='danger'>{error}</Message>}
      {loading && <Loader />}
      <Form onSubmit={submitHandler}>
        <Form.Group className='mb-3' controlId='email'>
          <Form.Label>Email Address</Form.Label>
          <Form.Control
            ref={inputRef}
            type='email'
            placeholder='Enter email'
            value={email}
            autoComplete='email'
            onChange={(e) => setEmail(e.target.value)}
          />
        </Form.Group>
        <Form.Group className='mb-3' controlId='password'>
          <Form.Label>Password</Form.Label>
          <Form.Control
            type='password'
            placeholder='Enter Password (minimum 6 characters)'
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
        </Form.Group>

        <Button
          type='submit'
          variant='outline-primary'
          style={{
            borderColor: theme.accent,
            color: theme.accent,
            backgroundColor: 'transparent'
          }}
        >
          Sign In
        </Button>
        <Button
          as={Link}
          to='/businessregister'
          variant='outline-primary'
          style={{
            borderColor: theme.accent,
            color: theme.accent,
            backgroundColor: 'transparent'
          }}
        >
          Register Here
        </Button>
      </Form>
    </FormContainer>
  )
}

export default OwnerLoginScreen
